module.exports = __webpack_public_path__ + "img/tribes.4b051125.svg";